import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useCallback,
  useImperativeHandle,
  useMemo,
} from "react";
import { fnGetDataSet } from "@shared/api/restApi";
import {
  getInitFormData,
  applySlip,
  CalAm,
  CalAmBulk,
} from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SharedForm from "../../../../../widgets/SharedForm";
import { fnSave } from "@shared/api/restApi";
import { menuInfo } from "@shared/type/CommonType";
import { showDialog } from "@widgets/CommonDialog";
import SnGrid from "@shared/components/GridV2/SnGrid";
import SnResizable from "@shared/components/SnResizable";
import usePanelSizes from "@shared/hooks/usePanelSizes";
import { showPopupModal } from "@widgets/CommonModal";
import SnFileUploadBox from "@shared/components/SnFileUploadBox";
import SN_TRA_ILC_REG_001_POP_001 from "./SN_TRA_ILC_REG_001_POP_001";
import SN_TRA_ILC_REG_001_POP_002 from "./SN_TRA_ILC_REG_001_POP_002";
import { CellValueChangedEvent } from "@shared/components/GridV2/SnGridTypes";
import SnButton from "@shared/components/SnButton";
import { RowNode } from "ag-grid-enterprise";
import SnForm, { ValueChangedEvent } from "@widgets/SnForm";
import { dateToString } from "@shared/utils/DateUtils";
import { RowApiModule } from "ag-grid-community";
import { RestaurantRounded } from "@mui/icons-material";
interface Props {
  Menuprops: menuInfo;
}

interface RowData {
  KeyField?: string; // 행의 고유 ID
  [key: string]: any;
}

const SN_TRA_ILC_REG_001 = forwardRef(({ Menuprops }: Props, ref) => {
  //#region  variable
  const { userInfo } = global(); // Login user 정보
  const SharedFormref1 = useRef<any>();
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    grid1: React.createRef(),
  });
  const [columns, setColums] = useState<any>({
    grid1: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
  });
  const formRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    freeform1: React.createRef(),
  });
  const [formControls, setFormControls] = useState<any>({
    freeform1: [],
  });
  const [formDatas, setFormDatas] = useState<any>({
    freeform1: null,
  });
  const today = new Date();
  const [selectedDocu, setSelectedDocu] = useState<string>("");
  const [selectedLineDocu, setSelectedLineDocu] = useState<number>(0);
  const todayform = `${today.getFullYear()}${(today.getMonth() + 1)
    .toString()
    .padStart(2, "0")}${today.getDate().toString().padStart(2, "0")}`;

  //#region  Components useState
  const [sharedForm, setSharedForm] = useState<any[]>([]);

  const [focusedRowData, setFocusedRowData] = useState<any>();
  const [gridFocus1, setGridFocus1] = useState(false);
  const [gridFocus2, setGridFocus2] = useState(false);

  //#endregion

  //#region panel 사이즈 관련
  const cd_menu = Menuprops.cd_menu || "SN_TRA_ILC_REG_001";
  const defaultSize = {
    panel1: "58.5%",
    panel2: "39.5%",
    panel3: "10.5%",
  };
  const [sizes, onResizeStop] = usePanelSizes(cd_menu, defaultSize); // SnResizable들의 크기

  //#endregion

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setColums({
          grid1: rtn.grid.grid2,
        });
        setFormControls({
          freeform1: rtn.form.freeform1,
        });
      } catch (error) {}
    };
    fetchform();
  }, []);

  useImperativeHandle(ref, () => ({
    onSearch,
    onInsert,
    onDelete,
    onSave,
  }));

  //region OnSearch
  const onSearch = async () => {
    const modifiedRowsH = formRefs.current["freeform1"].current.getChange();
    const modifiedRowsL = gridRefs.current["grid1"].current.getChange();

    if (
      modifiedRowsH.modifiedRowcount > 0 ||
      modifiedRowsL.modifiedRowcount > 0
    ) {
      const confirm = await showDialog(
        "confirm",
        "수정된 내용이 있습니다. 저장하시겠습니까?"
      );
      if (confirm) {
        await onSave();
      }
    }
    try {
      await search_popup();
    } catch (error) {}
  };
  //region getPopupInitialData
  const getPopupInitialData = () => {
    let cd_cust = "";
    let nm_cust = "";

    const rowCount = gridRefs.current["grid1"].current.getDisplayedRowCount();
    if (rowCount > 0) {
      const rowNode = gridRefs.current["grid1"].current.getSelectedRows(0); // always one row
      if (rowNode?.data) {
        cd_cust = cd_cust || rowNode.data.cd_cust || "";
        nm_cust = nm_cust || rowNode.data.nm_cust || "";
      }
    }

    return { cd_cust, nm_cust };
  };
  //region search_popup
  const search_popup = async () => {
    const selectedData = getPopupInitialData();
    const component = (
      <SN_TRA_ILC_REG_001_POP_001 selectedData={selectedData} />
    );
    const result = await showPopupModal({
      title: "L/C도움",
      children: component,
    });
    if (!result || result === "close") return;
    const headerResult = result[0];
    const newData = { no_lc: headerResult[0].no_lc };
    const params = {
      id: "sn_tra_ilc_reg_001_01",
      params: { ...newData },
    };
    const data: any = await fnGetDataSet(params);
    setSelectedDocu(headerResult[0].no_lc);
    setFormDatas({
      freeform1: data[0][0],
    });
    setDataSources({
      grid1: data[1] || [],
    });
  };

  //region onInsert
  const onInsert = async () => {
    try {
      const modifiedRowsH = formRefs.current["freeform1"].current.getChange();
      if (modifiedRowsH.modifiedRowcount > 0) {
        const confirm = await showDialog(
          "confirm",
          "수정중인 건이 있습니다. 저장하지 않고 계속 하시겠습니까?"
        );
        if (!confirm) return;
      }
      formRefs.current["freeform1"].current.resetUpdate();
      gridRefs.current["grid1"].current?.deleteAllRows();
      gridRefs.current["grid1"].current.resetUpdate();

      const newRow = {
        cd_firm: userInfo.cd_firm,
        cd_biz: userInfo.cd_biz,
        cd_dept: userInfo.cd_dept,
        nm_dept: userInfo.nm_dept,
        cd_cust: userInfo.cd_cust,
        dt_amend: todayform,
        no_hst_amend: 0,
        dy_pay: 0,
        rt_exch: 0,
        yn_partial: "N",
        fg_trns: "4",
        cd_gp: userInfo.cd_gp,
        nm_gp: userInfo.nm_gp,
        cd_emp: userInfo.cd_emp,
        nm_emp: userInfo.nm_emp,
        dt_lc: todayform,
        dt_due: todayform,
        dt_open: todayform,
        tp_lc: "001",
        am: 0,
        am_k: 0,
        no_lc: "",
      };
      formRefs.current["freeform1"].current.addRow(newRow);
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };

  //region onDelete
  const onDelete = async () => {
    if (!formRefs.current["freeform1"].current.checkDataExist()) {
      return;
    }
    const confirm = await showDialog("confirm", "삭제 하시겠습니까?");

    if (!confirm) {
      return;
    }

    gridRefs.current["grid1"].current?.deleteAllRows();
    formRefs.current["freeform1"].current?.deleteForm();

    return await onSave();
  };
  //region onDeleteRow
  const onDeleteRow = async () => {
    const selectedRows =
      gridRefs.current["grid1"].current?.getSelectedRows?.() || [];

    if (selectedRows.length === 0) return;

    const hasSavedRow = selectedRows.some((row: any) => row.state !== "insert");

    if (hasSavedRow) {
      await showDialog("alert", "저장된 데이터는 삭제할 수 없습니다.");
      return;
    }
    gridRefs.current["grid1"].current?.deleteSelectedRows();
  };

  //region OnSave
  const onSave = async () => {
    try {
      gridRefs.current["grid1"].current.stopEditing();

      const requiredValuesCheckH =
        formRefs.current["freeform1"].current.requiredValuesCheck();
      if (!requiredValuesCheckH) {
        return;
      }
      const requiredValuesCheckL =
        gridRefs.current["grid1"].current.requiredValuesCheck();
      if (!requiredValuesCheckL) {
        return;
      }

      const traIlchhChanges = formRefs.current["freeform1"].current.getChange();
      const traIlclhChanges = gridRefs.current["grid1"].current.getChange();
      if (
        traIlchhChanges.modifiedRowcount === 0 &&
        traIlclhChanges.modifiedRowcount === 0
      ) {
        await showDialog("alter", "변경된 내용이 없습니다.");
        return;
      }

      const headerInserts = traIlchhChanges.insert ?? [];
      if (headerInserts.length !== 0) {
        const noSlip = await applySlip({
          cd_column: "no_lc",
          cd_module: Menuprops.cd_module,
          no_line: 1,
          cd_prefix: "ILC",
          dt: headerInserts[0]?.dt_open,
          girdrefs: [gridRefs.current["grid1"]],
          formrefs: [formRefs.current["freeform1"]],
          inserts: [traIlchhChanges, traIlclhChanges],
          cd_menu: Menuprops.cd_menu,
        });
      }

      const SaveData = {
        tra_ilchh: traIlchhChanges,
        tra_ilclh: traIlclhChanges,
      };
      await fnSave("SN_TRA_ILC_REG_001_SAVE_01", SaveData);
      formRefs.current["freeform1"].current.resetUpdate();
      gridRefs.current["grid1"].current.resetUpdate();
    } catch (error: any) {}
  };
  const onAddRow = () => {
    try {
      const maxNoLine =
        gridRefs.current["grid1"].current.getMaxValue("no_line");

      const formData = formRefs.current["freeform1"].current.getFormdata();
      const noLc = formData?.no_lc;
      const newRow = {
        cd_firm: userInfo.cd_firm,
        no_lc: noLc,
        no_line: maxNoLine + 1,
        no_line_isu: maxNoLine + 1,
        no_line_so: maxNoLine + 1,
        no_hst: 1,
        no_hst_amend: 0,
        dt_dlv: todayform,
      };
      return gridRefs.current["grid1"].current?.addRow(newRow);
    } catch (error: any) {}
  };
  //region BTNclick
  const onGridBtnsClick = async (id: string) => {
    if (id === "aButton_ORDER") {
      const modifiedRowH = formRefs.current["freeform1"].current.getChange();
      if (modifiedRowH.insert.length == 0) {
        await showDialog("alter", "신규행을 추가하시기 바랍니다.");
        return;
      }

      // 발주적용 팝업은 헤더(freeform1)의 사업장을 그대로 따라간다.
      // 안 넘기면 팝업이 메타 기본값(공백)으로 떠서 조회가 안 된다.
      const headerForm =
        formRefs.current["freeform1"].current.getFormdata() ?? {};
      const component = (
        <SN_TRA_ILC_REG_001_POP_002
          selectedData={{ cd_biz: headerForm.cd_biz || userInfo.cd_biz }}
        />
      );
      const result = await showPopupModal({
        title: "발주적용",
        children: component,
        width: "80%",
      });
      if (!result || result === "close") return;
      let headerResult: any[] = result[0];

      if (headerResult[0]) {
        for (const key in headerResult[0]) {
          formRefs.current["freeform1"].current.setDataValue(
            key,
            headerResult[0][key],
            "noEvent"
          );
        }
      }

      const cd_exch = headerResult[0].cd_exch;
      const lineResult: any[] = result[1];
      const firstRtExch = lineResult[0]?.rt_exch;

      const isDifferent = lineResult.some(
        (row: any) => row.rt_exch !== firstRtExch
      );
      formRefs.current["freeform1"].current.setDataValue(
        "rt_exch",
        isDifferent ? 0 : firstRtExch,
        "noEvent"
      );

      lineResult.map((result: any) => {
        const rowNode = onAddRow();

        if (!rowNode) return;

        for (const key in result) {
          rowNode.setDataValue(key, result[key], "noEvent");
        }
        rowNode.setDataValue("cd_exch", cd_exch, "noEvent");
        rowNode.setDataValue("dt_dlv", todayform, "noEvent");
        rowNode.setDataValue("no_line_po", result.no_line, "noEvent");
        rowNode.setDataValue(
          "no_line_rcv",
          result.no_line_rcv === undefined ? 0 : result.no_line_rcv,
          "noEvent"
        );
      });

      await CalAmBulk(
        formRefs.current["freeform1"],
        gridRefs.current["grid1"],
        "rt_exch"
      );
    }
  };

  //region OnValueChanged
  const onValueChaged = async (event: ValueChangedEvent) => {
    if (!event) return;

    const colId = event.colId;
    const rowData = event.rowData;
    await CalAmBulk(
      formRefs.current["freeform1"],
      gridRefs.current["grid1"],
      colId
    );
  };
  //#region onCellValueChanged
  const onCellValueChangedL = async (event: CellValueChangedEvent) => {
    if (!event) return;

    const colId = event.colId;
    const rowData = event.rowData;
    const rowNode = event.rowNode;
    await CalAm(
      formRefs.current["freeform1"],
      gridRefs.current["grid1"],
      colId
    );
  };
  const onAfterSetFooter = async (data: any) => {
    formRefs.current["freeform1"].current.setDataValue(
      "am",
      data.am,
      "noEvent"
    );
    formRefs.current["freeform1"].current.setDataValue(
      "am_k",
      data.am_k,
      "noEvent"
    );
  };
  //#endregion
  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
        events: {
          onCellValueChanged: onCellValueChangedL,
          onBtnDeleteClick: onDeleteRow,
          onAfterSetFooter: onAfterSetFooter,
        },
      },
    }),
    [columns, dataSources]
  );
  const forms = useMemo(
    () => ({
      freeform1: {
        controls: formControls.freeform1,
        data: formDatas.freeform1,
        etcProps: {},
        events: {
          onValueChanged: onValueChaged,
        },
      },
    }),
    [formControls, formDatas]
  );

  //#region  UI
  return (
    <div className="h-full flex flex-col">
      <div className="flex-1 h-full min-h-0 space-y-1.5">
        <SnResizable
          direction={"height"}
          seq={1}
          cd_menu={cd_menu}
          defaultSize={defaultSize}
          size={sizes.panel1}
          onResizeStop={onResizeStop}
          enable={{ bottom: true }}
          minWidth={130}
        >
          <SnForm
            ref={formRefs.current["freeform1"]}
            data={forms.freeform1.data}
            controls={forms.freeform1.controls}
            etcProps={forms.freeform1.etcProps}
            events={forms.freeform1.events}
          ></SnForm>
        </SnResizable>
        <SnResizable
          direction={"height"}
          seq={2}
          cd_menu={cd_menu}
          defaultSize={defaultSize}
          size={sizes.panel2}
          onResizeStop={onResizeStop}
          enable={{ bottom: true }}
          minHeight={130}
        >
          <SnGrid
            ref={gridRefs.current["grid1"]} // Grid Name
            columnConfig={grids.grid1.columns} // 컬럼 설정 전달
            rowData={grids.grid1.dataSource} // Datasource
            etcProps={{
              isEditable: true,
              rowSelection: "multiple",
              title: "상세정보",
            }}
            events={grids.grid1.events}
            header={
              <div>
                <SnButton
                  text={"발주적용"}
                  onClick={() => {
                    onGridBtnsClick("aButton_ORDER");
                  }}
                />
              </div>
            }
          />
        </SnResizable>

        <SnFileUploadBox
          selectedDocu={selectedDocu}
          selectedLineDocu={selectedLineDocu}
        />
      </div>
    </div>
  );
  //#endregion
});
export default SN_TRA_ILC_REG_001;
